import { VisualizationShape, VisualizationStyle } from './types';

const SHAPE_MARKUP: Record<VisualizationShape, string> = {
  circle: '<circle cx="12" cy="12" r="11" />',
  square: '<rect x="1" y="1" width="22" height="22" rx="0.5" />',
  triangle: '<polygon points="12,1 23,22 1,22" />',
  rhombus: '<polygon points="12,1 23,12 12,23 1,12" />',
  star:
    '<polygon points="12,1 15.4,8 23,9 17.5,14.3 18.8,22 12,18.4 5.2,22 6.5,14.3 1,9 8.6,8" />',
};

export function createVisualizationSvg(style: VisualizationStyle): string {
  const shape = SHAPE_MARKUP[style.shape];
  const secondary = style.secondaryColor
    ? `<g clip-path="url(#right-half)" fill="${style.secondaryColor}">${shape}</g>`
    : '';
  const outline = style.outlined
    ? `<g fill="none" stroke="#111111" stroke-width="1.5" stroke-linejoin="round">${shape}</g>`
    : '';

  return [
    '<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 24 24">',
    '<defs><clipPath id="right-half"><rect x="12" y="0" width="12" height="24" /></clipPath></defs>',
    `<g fill="${style.primaryColor}">${shape}</g>`,
    secondary,
    outline,
    '</svg>',
  ].join('');
}

export function createVisualizationIconUrl(
  style: VisualizationStyle
): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
    createVisualizationSvg(style)
  )}`;
}

export function createVisualizationFillIconUrl(
  style: VisualizationStyle
): string {
  return createVisualizationIconUrl({ ...style, outlined: false });
}

export function createVisualizationOutlineIconUrl(
  shape: VisualizationShape
): string {
  return createVisualizationIconUrl({
    shape,
    primaryColor: '#000000',
    secondaryColor: null,
    sizeScale: 1,
    outlined: false,
  });
}

export function getVisualizationStyleKey(style: VisualizationStyle): string {
  return [
    style.shape,
    style.primaryColor.toLowerCase(),
    style.secondaryColor?.toLowerCase() || 'single',
    style.sizeScale,
    style.outlined ? 'outlined' : 'plain',
  ].join(':');
}
